import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  OnInit,
  signal,
} from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { VisorgisService } from '../../services/visorgis.service';
import { FormControl, FormsModule } from '@angular/forms';
import { SelectMaterialComponent } from '../../../../shared/components/select-material/select-material.component';
import { TituloComponent } from '../../../../shared/components/titulo/titulo.component';
import { MatIconModule } from '@angular/material/icon';
import { mergeAll, tap } from 'rxjs/operators';
import { forkJoin, merge, of, Subscription } from 'rxjs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TooltipDirective } from 'src/app/shared/directives/tooltip.directive';
import { TurnoSemanal } from '../../interfaces/turnoSemanal.interface';
import {
  ConfiguracionService,
  NetworkIntervalsResponse,
} from 'src/app/pages/configuracion/services/configuracion.service';
import { catchError, map } from 'rxjs/operators';
import { VisorgisSector } from '../../utils/sector.utils';
import { DataService } from '../../../../services/data/data.service';

@Component({
  selector: 'app-modal-gis',
  imports: [
    MatSlideToggleModule,
    FormsModule,
    SelectMaterialComponent,
    TituloComponent,
    MatIconModule,
    TooltipDirective,
    MatTooltipModule,
  ],
  templateUrl: './modal-gis.component.html',
  styleUrl: './modal-gis.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalGisComponent implements OnInit, OnDestroy, AfterViewInit {
  private readonly service = inject(VisorgisService);
  private readonly configuracionService = inject(ConfiguracionService);
  private readonly dataService = inject(DataService);

  private readonly allSectorsOptionValue = '__ALL_SECTORS__';

  tuberiaSectorForm = new FormControl<string | null>(null);
  sectoresTuberias = signal<{ value: string | null; viewValue: string }[]>([]);
  sectorForm = new FormControl<Array<number | string>>([]);
  sectoresUnicos = signal<{ value: number | string; viewValue: string }[]>([]);
  turnos = [
    { value: 'todos', viewValue: '(Todos)' },
    { value: 'Turno 1', viewValue: 'Turno 1' },
    { value: 'Turno 2', viewValue: 'Turno 2' },
    { value: 'Turno 3', viewValue: 'Turno 3' },
    { value: 'Turno 4', viewValue: 'Turno 4' },
  ];
  dias = [
    { value: 'todos', viewValue: '(Todos)' },
    { value: 'lunes', viewValue: 'Lunes' },
    { value: 'martes', viewValue: 'Martes' },
    { value: 'miercoles', viewValue: 'Miércoles' },
    { value: 'jueves', viewValue: 'Jueves' },
    { value: 'viernes', viewValue: 'Viernes' },
    { value: 'sabado', viewValue: 'Sábado' },
    { value: 'domingo', viewValue: 'Domingo' },
  ];

  turnoControl: FormControl = new FormControl(0);
  diaControl: FormControl = new FormControl(0);
  highNetworkIntervalHours = signal(24);
  lowNetworkIntervalHours = signal(48);

  get depositos() {
    return this.service.depositos.getValue();
  }

  set depositos(value) {
    this.service.depositos.next(value);
  }

  get pozos() {
    return this.service.pozos.getValue();
  }

  set pozos(value) {
    this.service.pozos.next(value);
  }

  get cabezales() {
    return this.service.cabezales.getValue();
  }

  set cabezales(value) {
    this.service.cabezales.next(value);
  }

  get hidrantes() {
    return this.service.hidrantes.getValue();
  }

  get other_hydraulic() {
    return this.service.other_hydraulic.getValue();
  }

  set other_hydraulic(value) {
    this.service.other_hydraulic.next(value);
  }

  get other_energy_facilities() {
    return this.service.other_energy_facilities.getValue();
  }

  set other_energy_facilities(value) {
    this.service.other_energy_facilities.next(value);
  }

  get other_network_elements() {
    return this.service.other_network_elements.getValue();
  }

  set other_network_elements(value) {
    this.service.other_network_elements.next(value);
  }

  set hidrantes(value) {
    this.service.hidrantes.next(value);
  }
  get red() {
    return this.service.red.getValue();
  }
  set red(value) {
    this.service.red.next(value);
  }
  get impulsion() {
    return this.service.impulsion.getValue();
  }
  set impulsion(value) {
    this.service.impulsion.next(value);
  }
  get parcelas() {
    return this.service.parcelas.getValue();
  }
  set parcelas(value) {
    this.service.parcelas.next(value);
  }
  get tomas() {
    return this.service.tomas.getValue();
  }
  set tomas(value) {
    this.service.tomas.next(value);
  }

  get balsas() {
    return this.service.balsas.getValue();
  }
  set balsas(value) {
    this.service.balsas.next(value);
  }

  get tuberias() {
    return this.service.tuberias.getValue();
  }
  set tuberias(value) {
    this.service.tuberias.next(value);
  }

  get parcelas_comunero() {
    return this.service.parcelas_comunero.getValue();
  }
  set parcelas_comunero(value) {
    this.service.parcelas_comunero.next(value);
  }

  get estaciones() {
    return this.service.estaciones.getValue();
  }
  set estaciones(value) {
    this.service.estaciones.next(value);
  }

  get dispositivos_energia() {
    return this.service.dispositivos_energia.getValue();
  }

  set dispositivos_energia(value) {
    this.service.dispositivos_energia.next(value);
  }

  get analizadores_red() {
    return this.service.analizadores_red.getValue();
  }

  set analizadores_red(value) {
    this.service.analizadores_red.next(value);
  }

  get necesidades_riego() {
    return this.service.necesidades_riego.getValue();
  }

  set necesidades_riego(value) {
    this.service.necesidades_riego.next(value);
  }

  get piezometria() {
    return this.service.piezometria.getValue();
  }

  set piezometria(value) {
    this.service.piezometria.next(value);
  }

  get cas_nitratos() {
    return this.service.cas_nitratos.getValue();
  }

  set cas_nitratos(value) {
    this.service.cas_nitratos.next(value);
  }

  get sigpac_recinto() {
    return this.service.sigpac_recinto.getValue();
  }

  set sigpac_recinto(value) {
    this.service.sigpac_recinto.next(value);
  }

  get sigpac_cultivo_declarado() {
    return this.service.sigpac_cultivo_declarado.getValue();
  }

  set sigpac_cultivo_declarado(value) {
    this.service.sigpac_cultivo_declarado.next(value);
  }

  get sigpac_e_paisaje() {
    return this.service.sigpac_e_paisaje.getValue();
  }

  set sigpac_e_paisaje(value) {
    this.service.sigpac_e_paisaje.next(value);
  }

  get sigpac_e_paisaje_linea() {
    return this.service.sigpac_e_paisaje_linea.getValue();
  }

  set sigpac_e_paisaje_linea(value) {
    this.service.sigpac_e_paisaje_linea.next(value);
  }

  get sigpac_e_paisaje_punto() {
    return this.service.sigpac_e_paisaje_punto.getValue();
  }

  set sigpac_e_paisaje_punto(value) {
    this.service.sigpac_e_paisaje_punto.next(value);
  }

  get filtroActivos() {
    return this.service.filtroActivos.getValue();
  }

  set filtroActivos(value) {
    this.service.filtroActivos.next(value);
  }

  get filtroInactivos() {
    return this.service.filtroInactivos.getValue();
  }

  set filtroInactivos(value) {
    this.service.filtroInactivos.next(value);
  }

  get filtroSinContador() {
    return this.service.filtroSinContador.getValue();
  }

  set filtroSinContador(value) {
    this.service.filtroSinContador.next(value);
  }

  get riegoHoy() {
    return this.service.riegoHoy.getValue();
  }

  set riegoHoy(value) {
    this.service.riegoHoy.next(value);
  }

  get riegoAyer() {
    return this.service.riegoAyer.getValue();
  }

  set riegoAyer(value) {
    this.service.riegoAyer.next(value);
  }

  get riego7dias() {
    return this.service.riego7dias.getValue();
  }

  set riego7dias(value) {
    this.service.riego7dias.next(value);
  }

  get listadoParcelas() {
    return this.service.listadoElementos;
  }

  private syncEnergiaModuleVisibility(): void {
    this.showEnergiaModule.set(!!this.dataService.isEnergia());
  }

  showEnergiaModule = signal(false);

  getSectoresTuberias$?: Subscription;
  getSectoresUnicos$?: Subscription;

  ngOnInit(): void {
    if (this.dataService.enabledMenuOpts.length === 0) {
      this.dataService.getEnabledMenuOpts().subscribe(() => {
        this.syncEnergiaModuleVisibility();
      });
    } else {
      this.syncEnergiaModuleVisibility();
    }

    this.getSectoresTuberias$ = this.initSectoresTuberias().subscribe();
    this.getSectoresUnicos$ = this.initSectoresUnicos().subscribe();

    // Sincronizar los valores iniciales con el servicio
    this.sincronizarFiltros();
    this.getNetworkIntervals();
  }

  getNetworkIntervals() {
    return this.configuracionService
      .getNetworkIntervals()
      .pipe(
        map((response: NetworkIntervalsResponse) => {
          this.highNetworkIntervalHours.set(
            response.high_network_interval_hours
          );
          this.lowNetworkIntervalHours.set(response.low_network_interval_hours);
        }),
        catchError(() => of(null))
      )
      .subscribe();
  }

  // Método para sincronizar los filtros con el estado actual del servicio
  sincronizarFiltros() {
    this.tuberiaSectorForm.setValue(
      this.service.selectedTuberiaSector.getValue(),
      {
        emitEvent: false,
      }
    );
    this.sectorForm.setValue(this.service.selectedSectorIds.getValue(), {
      emitEvent: false,
    });
    this.parcelas_comunero = this.service.parcelas_comunero.getValue();
    this.parcelas = this.service.parcelas.getValue();
    this.pozos = this.service.pozos.getValue();
    this.balsas = this.service.balsas.getValue();
    this.cabezales = this.service.cabezales.getValue();
    this.hidrantes = this.service.hidrantes.getValue();
    this.tomas = this.service.tomas.getValue();
    this.tuberias = this.service.tuberias.getValue();
    this.estaciones = this.service.estaciones.getValue();
    this.dispositivos_energia = this.service.dispositivos_energia.getValue();
    this.analizadores_red = this.service.analizadores_red.getValue();
    this.necesidades_riego = this.service.necesidades_riego.getValue();
    this.piezometria = this.service.piezometria.getValue();
    this.cas_nitratos = this.service.cas_nitratos.getValue();
    this.sigpac_recinto = this.service.sigpac_recinto.getValue();
    this.sigpac_cultivo_declarado =
      this.service.sigpac_cultivo_declarado.getValue();
    this.sigpac_e_paisaje = this.service.sigpac_e_paisaje.getValue();
    this.sigpac_e_paisaje_linea =
      this.service.sigpac_e_paisaje_linea.getValue();
    this.sigpac_e_paisaje_punto =
      this.service.sigpac_e_paisaje_punto.getValue();
    this.other_hydraulic = this.service.other_hydraulic.getValue();
    this.other_energy_facilities =
      this.service.other_energy_facilities.getValue();
    this.other_network_elements =
      this.service.other_network_elements.getValue();

    // Estado de elementos
    this.filtroActivos = this.service.filtroActivos.getValue();
    this.filtroInactivos = this.service.filtroInactivos.getValue();
    this.filtroSinContador = this.service.filtroSinContador.getValue();

    // Filtros de riego
    this.riegoHoy = this.service.riegoHoy.getValue();
    this.riegoAyer = this.service.riegoAyer.getValue();
    this.riego7dias = this.service.riego7dias.getValue();

    // Turno y día
    this.turnoControl.setValue(
      this.service.turnoFiltro ? this.service.turnoFiltro : 0
    );
    this.diaControl.setValue(
      this.service.diaFiltro ? this.service.diaFiltro : 0
    );
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    if (this.tuberiaSectorForm) {
      this.tuberiaSectorForm.valueChanges
        .pipe(
          tap(sector => {
            this.onTuberiaSectorChange(sector);
          })
        )
        .subscribe();
    }
    if (this.sectorForm) {
      this.sectorForm.valueChanges
        .pipe(
          tap(sector => {
            this.onSectorChange(sector);
          })
        )
        .subscribe();
    }
    if (this.turnoControl) {
      this.turnoControl.valueChanges
        .pipe(
          tap(turno => {
            this.onTurnoChange(turno);
          })
        )
        .subscribe();
    }
    if (this.diaControl) {
      this.diaControl.valueChanges
        .pipe(
          tap(dia => {
            this.onDiaChange(dia);
          })
        )
        .subscribe();
    }
  }

  cancelar() {
    this.service.closeMenu();
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.getSectoresTuberias$?.unsubscribe();
    this.getSectoresUnicos$?.unsubscribe();
  }

  initSectoresTuberias() {
    return this.service.availableTuberiaSectors.pipe(
      tap((sectores: string[]) => {
        const sectoresTuberias = [
          {
            value: null,
            viewValue: '(Todos)',
          },
          ...sectores
            .slice()
            .sort((sectorA, sectorB) =>
              sectorA.localeCompare(sectorB, 'es', {
                sensitivity: 'base',
              })
            )
            .map(sector => ({
              value: sector,
              viewValue: sector,
            })),
        ];

        this.sectoresTuberias.set(sectoresTuberias);
      })
    );
  }

  initSectoresUnicos() {
    return this.service.availableSectors.pipe(
      tap((sectores: VisorgisSector[]) => {
        const sectoresUnicos = [
          {
            value: this.allSectorsOptionValue,
            viewValue: 'Desmarcar todos',
          },
          ...sectores
            .slice()
            .sort((sectorA, sectorB) =>
              sectorA.name.localeCompare(sectorB.name, 'es', {
                sensitivity: 'base',
              })
            )
            .map(sector => ({
              value: sector.id,
              viewValue: sector.name,
            })),
        ];

        this.sectoresUnicos.set(sectoresUnicos);
      })
    );
  }

  onTuberiaSectorChange(sector: string | null) {
    this.service.selectedTuberiaSector.next(
      typeof sector === 'string' && sector.trim().length > 0 ? sector : null
    );
  }

  onSectorChange(sectorIds: Array<number | string> | null) {
    if (
      Array.isArray(sectorIds) &&
      sectorIds.includes(this.allSectorsOptionValue)
    ) {
      this.sectorForm.setValue([], { emitEvent: false });
      this.service.selectedSectorIds.next([]);
      return;
    }

    this.service.selectedSectorIds.next(
      Array.isArray(sectorIds)
        ? sectorIds.filter(
            (sectorId): sectorId is number => typeof sectorId === 'number'
          )
        : []
    );
  }

  onTurnoChange(turno: string | number | null) {
    this.service.turnoFiltro.next(turno);
    console.log('turno', turno);
  }
  onDiaChange(dia: string | number | null) {
    this.service.diaFiltro.next(dia);
    console.log('dia', dia);
  }
}
